import React, { Component } from "react";
import { Multiselect } from "react-widgets";
import "react-widgets/styles.css";

export default class MultiselectField extends Component {

  state = {
    active: false
  };

  handleFocus = () => {
    this.setState({ active: true });
  };

  handleBlur = () => {
    this.setState({ active: false });
  };

  render = () => {
    const { active } = this.state;
    // eslint-disable-next-line
    const { input, meta, options, placeholder, required, ...rest } = this.props;
    const { touched, error } = meta;
    // const { warning } = meta;

    const wrapperClass = touched && error ? " error-text error-border" : "";
    const focusClass = active ? " field-focus" : "";
    const errorClass = touched && error ? "error-border" : null;
    const hasValue = input.value.length;

    // Build class name string for placholder
    let placeholderClass = "multiselect-label noselect form-label";
   
    placeholderClass += " form-label-not-empty";
   
    if (touched && error) {
      placeholderClass += " error-text";
    }

    let value = input.value;
    if (input.value === "") {
      value = null;
    }

    return (
      <div
        className={`input-wrapper--form-control-wrapper-component focus-fix${wrapperClass}`}
        tabIndex="-1"
        onClick={() => this.handleFocus()}
      >
        <div className={`field-focus-wrapper${focusClass}`} />
        <label htmlFor={input.name} className={placeholderClass}>
          {placeholder}
        </label>

        <Multiselect
          {...input}
          value={value || []}
          currentValue={value || []}
          name={input.name}
          className={errorClass}
          onBlur={this.handleBlur} // Fix to prevent redux-form parse from trying to parse null value
          onFocus={this.handleFocus}
          placeholder={`${placeholder} ${required ? "*" : ""}`}
          {...rest}
    />
      </div>
    );
  };
}
